import type { AcquisitionRequest } from "@/lib/api/acquisitions";

type RequestBibliographyProps = {
  request: AcquisitionRequest;
};

export function RequestBibliography({ request }: RequestBibliographyProps) {
  const authors = request.authors?.filter(Boolean) ?? [];
  const editors = request.editors?.filter(Boolean) ?? [];
  const shownAuthors = authors.length ? authors : request.author ? [request.author] : [];

  return (
    <div className="space-y-3 text-sm">
      {request.subtitle ? <p className="text-slate-600">{request.subtitle}</p> : null}
      {request.description ? (
        <p className="whitespace-pre-wrap text-slate-700">{request.description}</p>
      ) : null}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <NameLine label="Authors" value={shownAuthors.join(", ")} />
        <NameLine label="Editors" value={editors.join(", ")} />
        <NameLine label="Place of publication" value={request.placeOfPublication} />
        <NameLine
          label="Publication year"
          value={request.publicationYear != null ? String(request.publicationYear) : null}
        />
      </div>
    </div>
  );
}

function NameLine({ label, value }: { label: string; value?: string | null }) {
  return (
    <div>
      <span className="text-slate-500">{label}</span>
      <p className="font-medium text-slate-900">{value?.trim() ? value : "—"}</p>
    </div>
  );
}
